import { render, staticRenderFns } from "./unscheduledRespondentForm.vue?vue&type=template&id=0bbfca40&"
import script from "./unscheduledRespondentForm.vue?vue&type=script&lang=js&"
export * from "./unscheduledRespondentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports